import React, { useEffect, useRef, useState } from 'react';
import API_BASE_URL from "../../../apiConfig";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { jsPDF } from "jspdf";
import "jspdf-autotable";

const PanFindReportAdmin = () => {
  const [panFindData, setPanFindData] = useState([]);
  const tableRef = useRef(null);

  useEffect(() => {
    const fetchPanFindData = async () => {
      try {
        // Retrieve token from localStorage or sessionStorage
        const authToken = localStorage.getItem("authToken"); // or sessionStorage.getItem('token')

        const response = await fetch(`${API_BASE_URL}/PanFind/GetPanFindRecords`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${authToken}`, // Attach token in the request

          }
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        let data = await response.json();

        // Add SrNo property to each record
        data = data.map((record, index) => ({
          ...record,
          SrNo: index + 1 // Auto-incrementing SrNo
        }));

        setPanFindData(data); // Update state with modified data
      } catch (error) {
        console.error('Failed to fetch publication records:', error);
      }
    };

    fetchPanFindData();
  }, []);

  console.log(panFindData);

  // Function to update status
  const handleStatusChange = async (registrationNo, newStatus) => {
    const comment = prompt("Enter comment for this status change:");
    if (!comment) return; // Optional: require comment

    try {
      const authToken = localStorage.getItem("authToken");

      const response = await fetch(`${API_BASE_URL}/PanFind/updateStatus/${registrationNo}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({ status: newStatus, comment }),
      });

      if (!response.ok) throw new Error("Failed to update status");

      // Update UI state
      setPanFindData(prev =>
        prev.map(row =>
          row.registrationNo === registrationNo
            ? { ...row, status: newStatus, comment }
            : row
        )
      );

    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  useEffect(() => {
    if (tableRef.current && panFindData.length > 0) {
      const table = $(tableRef.current).DataTable({
        destroy: true, // Destroy existing table instance
        data: panFindData,
        columns: [
          { data: 'SrNo', title: 'Sr No' }, // Dynamically added field
          { data: 'startDate', title: 'Date' }, // Matches 'startDate'
          { data: 'name', title: 'Applicant Name' }, // Matches 'name'
          { data: 'registrationNo', title: 'Registration No' }, // Matches 'registrationNo'
          {
            data: 'status',
            title: 'Status',
            render: function (data, type, row) {
              return `
                  <select class="form-control status-dropdown" data-id="${row.registrationNo}">
                    <option value="In Progress" ${data === "In Progress" ? "selected" : ""}>In Progress</option>
                    <option value="Complete" ${data === "Complete" ? "selected" : ""}>Complete</option>
                    <option value="Rejected" ${data === "Rejected" ? "selected" : ""}>Rejected</option>
                    <option value="Refunded" ${data === "Refunded" ? "selected" : ""}>Refunded</option>
                    </select>
                `;
            }
          },
          { data: 'comment', title: 'Comment' },
          {
            data: null,
            title: "Submitted Form",
            render: function (data, type, row) {
              return `<button class='btn btn-sm btn-primary download-btn' data-id='${row.registrationNo}'>Download PDF</button>`;
            },
          },
        ]
      });

      // Handle download button click
      $('#productsTable tbody').off('click', '.download-btn').on('click', '.download-btn', function () {
        const registrationNo = $(this).data("id");
        downloadPDF(registrationNo);
      });

      // Handle status change
      $(tableRef.current).on("change", ".status-dropdown", function () {
        const registrationNo = $(this).attr("data-id");
        const newStatus = $(this).val();
        const comment = ""; // Or however you get it
        handleStatusChange(registrationNo, newStatus, comment);
      });

      return () => {
        table.destroy();
        $(tableRef.current).off("change", ".status-dropdown");
      };
    }
  }, [panFindData]);

  const downloadPDF = async (registrationNo) => {
    try {
      const authToken = localStorage.getItem("authToken");

      const response = await fetch(
        `${API_BASE_URL}/PanFind/DownloadPdf/${registrationNo}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to download file: ${response.status}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `PanFind_Report_${registrationNo}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  return (

    <table
      ref={tableRef}
      id="productsTable"
      className="table table-bordered table-hover table-product"
      style={{ width: '100%' }}
    >
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th>Date</th>
          <th>Applicant Name</th>
          <th>Registration No</th>
          <th>Status</th>
          <th>Comment</th>
          <th>Submitted Form</th>
        </tr>
      </thead>
    </table>

  );
};

export default PanFindReportAdmin;